import type { StringTable } from '../types'

export const ja: StringTable = {
  'common.playbackSpeed': '再生速度',
  // Navigation
  'nav.review': '復習',
  'nav.library': 'ライブラリ',
  'nav.stats': '統計',
  'nav.settings': '設定',
  'nav.appTitleSuffix': '単語フラッシュカード',
  'nav.openMenu': 'メニューを開く',
  'nav.closeMenu': 'メニューを閉じる',
  'nav.mainNav': 'メインナビゲーション',
  'nav.reviewSession': '復習セッション',
  'nav.cardLibrary': 'カードライブラリ',
  'nav.media': '動画',
  'nav.statistics': '統計情報',
  'nav.create.label': '作成',
  'nav.create.text': 'テキスト',
  'nav.create.doc': 'ドキュメント',
  'nav.create.media': '動画 / 音声',

  // Generate view
  'generate.takePhoto': '撮影',
  'generate.changePhoto': '写真を変更',
  'generate.chooseGallery': 'ギャラリー',
  'generate.clearText': 'テキストをクリア',
  'generate.button': 'カードを生成',
  'generate.buttonPhoto': '写真から生成',
  'generate.buttonText': 'テキストから生成',
  'generate.buttonBoth': '写真+テキストから生成',
  'generate.buttonLoading': '生成中...',
  'generate.minInput': '写真またはテキストを追加してください',
  'generate.convertingHeic': 'HEIC変換中...',
  'generate.compressing': '圧縮中...',
  'generate.retry': '再試行',
  'generate.removeImage': '画像を削除',
  'generate.cardTextInput': 'カードテキスト入力',
  'generate.preview': 'プレビュー',

  // Generate errors
  'generate.error.invalidImage': '画像をアップロードしてください（JPEG、PNG、GIF、WebP、HEIC）',
  'generate.error.imageTooLarge': '画像は{{maxSize}}未満にしてください',
  'generate.error.compressionFailed': '圧縮後も画像が大きすぎます。より小さい写真をお試しください。',
  'generate.error.heicFailed': '画像の処理に失敗しました',
  'generate.error.generateFailed': 'カードの生成に失敗しました',

  // Generate — daily cap / upgrade
  'generate.cap.body': '残高不足（{{balance}} エネルギー）。チャージして生成を続けよう。',
  'generate.cap.upgrade': 'チャージ',

  // Generate — energy badge + first-session banner (balance visibility)
  'generate.energyBadge.label': 'エネルギー残量：{{balance}}',
  'generate.energyBadge.zero': 'エネルギーがありません',
  'generate.firstCard.body': '{{balance}} エネルギーがあります — 最初のカードを作るには十分です。下に単語を入力して試してみましょう →',
  'generate.firstCard.dismiss': '閉じる',
  'generate.sampleWords.label': 'この単語で試してみましょう：',
  'generate.aiImageToggle': 'AI画像',
  'generate.aiImageHint': '残すカードに AI 画像を追加(1枚 {{cost}})',
  'generate.aiImageAutoSkip': '一部のAI画像を追加できませんでした — 各カードの画像ボタンをタップして再試行してください。',

  // Library view
  'library.loading': 'ライブラリを読み込み中...',
  'library.retry': '再試行',
  'library.noCards': 'まだカードがありません！',
  'library.noCardsHint': 'フラッシュカードを生成してライブラリを構築しましょう。',
  'library.emptyExtensionHint': 'ヒント:YouTube 視聴中に単語を選択して、Piccard 拡張機能でワンタップ保存。', 'library.emptyCta': '最初のカードを作る',
  'library.dismiss': '閉じる',
  'library.deleteTitle': 'カードを削除しますか？',
  'library.deleteConfirm': 'この操作は取り消せません。よろしいですか？',
  'library.cancel': 'キャンセル',
  'library.deleting': '削除中...',
  'library.delete': '削除',
  'library.filterAll': 'すべて',
  'library.filterLearning': '学習中',
  'library.filterMastered': '習得済み',
  'library.card_one': '{{count}}枚のカード',
  'library.card_other': '{{count}}枚のカード',
  'library.match_one': '{{count}}件の一致',
  'library.match_other': '{{count}}件の一致',
  'library.noCardsMatch': '「{{query}}」に一致するカードがありません',
  'library.prevPage': '前のページ',
  'library.nextPage': '次のページ',
  'library.searchImagesFor': '{{word}}の画像を検索',
  'library.unmaster': '{{word}}の習得を解除',
  'library.markMastered': '{{word}}を習得済みにする',
  'library.searchPlaceholder': '{{filter}}カードを検索...',
  'library.drag': 'ドラッグ',
  'library.swipeHint': '← 削除 · 詳細 →',
  'library.back': '裏面',
  'library.images': '画像',
  'library.master': '習得',
  'library.mastered': '習得済み',
  'library.view': '表示',
  'library.fromMedia': 'メディアから',
  'library.fromDoc': 'ドキュメントから',

  // Review view
  'review.ready': '復習の準備はできましたか？',
  'review.readyHint': 'トピックを選ぶか、すべての復習対象カードを始めましょう',
  'review.recognition': '認識',
  'review.production': '産出',
  'review.topics': 'トピック',
  'review.domains': '分野',
  'review.startReview': '復習を開始',
  'review.loading': 'カードを読み込み中...',
  'review.retry': '再試行',
  'review.tapFlip': 'タップして裏返す',
  'review.answer': '解答',
  'review.newWord': '新しい単語',
  'review.cardProgress': '{{total}}枚中{{current}}枚目',
  'review.searchImagesFor': '{{word}}の画像を検索',
  'review.allCaughtUp': 'すべて復習完了！',
  'review.nothingToReview': '今は復習するカードがありません。',
  'review.makeSomeCards': 'カードを作成する',
  'review.makeMoreCards': '「{{topic}}」のカードをもっと作る',
  'review.backToReview': '復習に戻る',
  'review.noMatchTitle': '「{{topic}}」に一致するカードがありません',
  'review.noMatchHint': 'トピックに部分一致するカードを表示しています',
  'review.fallbackTitle': '「{{topic}}」に一致するカードがありません — 復習対象の全カードを表示します',
  'review.sessionComplete': 'セッション完了！',
  'review.cardsReviewed': '復習したカード',
  'review.again': 'もう一度',
  'review.hard': '難しい',
  'review.good': '普通',
  'review.easy': '簡単',
  'review.timeSpent': '所要時間',
  'review.cardReviewed_one': '今日{{count}}枚のカードを復習しました',
  'review.cardReviewed_other': '今日{{count}}枚のカードを復習しました',
  'review.startNewSession': '新しいセッションを開始',

  // Share check-in card (issue #1 — /s/:slug poster pages)
  'share.cta': '今日の学習カードをシェア',
  'share.title': '学習記録をシェア',
  'share.name': '表示名',
  'share.create': 'シェアリンクを作成',
  'share.copied': 'リンクをコピーしました！',
  'share.open': 'シェアページを開く',
  'share.saveImage': 'シェア画像を保存',
  'share.myLinks': '自分のシェアリンク',
  'share.revoke': '取り消す',
  'share.empty': 'シェアリンクはまだありません — 復習を終えて連続記録をシェアしましょう。',
  'review.tapOrSpace': 'カードをタップまたはスペースキーで裏返す',
  'review.images': '画像',
  'review.prefillMore': '{{topic}}に関する単語と表現をもっと',
  'review.endSession': '終了',
  'review.error.loadFailed': 'カードの読み込みに失敗しました',
  'review.error.submitFailed': '復習結果の送信に失敗しました',

  // Stats view
  'stats.today': '今日',
  'stats.reviewedToday': '今日復習済み',
  'stats.review_one': '件の復習',
  'stats.review_other': '件の復習',
  'stats.mastered': '習得済み',
  'stats.learned': '覚えた単語',
  'stats.word_one': '単語',
  'stats.word_other': '単語',
  'stats.error': '統計の読み込みに失敗しました',
  'stats.dailyGoal': '1日の目標',
  'stats.goalFresh': '新しいスタート。',
  'stats.goalGoing': 'その調子。',
  'stats.goalMet': '目標達成、おつかれさま。',
  'stats.goalHint': 'タップでペース設定',

  // Settings view
  'settings.title': '設定',
  'settings.languagePair': '言語ペア',
  'settings.learn': '学習',
  'settings.pairOption': '{{native}} → {{target}}を学ぶ',
  'settings.pairGroup': '{{langA}} ↔ {{langB}}',
  'settings.cardsPerSession': '1セッションのカード数',
  'settings.cardLabel': '{{count}}枚',
  'settings.changeWarning': '言語を変更するとアプリが再読み込みされます',
  'settings.apply': '適用',
  'settings.cancelChange': 'キャンセル',

  // Settings — learning context (free-text goal that tunes AI generation)
  'settings.learningContext.label': '学習の目標',
  'settings.learningContext.optional': '任意',
  'settings.learningContext.placeholder': '例：GRE単語、HSK対策、ビジネス英語…',
  'settings.learningContext.hint': 'AIの単語選択に影響します。空欄でデフォルト。',
  'settings.learningContext.try': '候補：',
  'settings.learningContext.example1': 'HSK対策',
  'settings.learningContext.example2': 'ビジネス英語',
  'settings.learningContext.example3': '日常会話',
  'settings.learningContext.example4': 'オーストラリア英語',

  // Settings — subscription
  'settings.plan.balanceTitle': 'エネルギー残高',
  'settings.plan.balanceDesc': '利用可能 {{balance}} エネルギー',
  'settings.plan.topup': '${{amount}} チャージ',
  'settings.plan.energyUnit': '{{energy}} エネルギー',
  'settings.plan.bonusPct': '+{{percent}}% ボーナス',
  'settings.plan.bestValue': 'お得',
  'settings.support.title': 'お困りですか？',
  'settings.support.desc': 'ご質問・お支払い・フィードバック — いつでもメールで。',
  'settings.referral.title': '友達を招待して、お互い 150 エネルギーを GET',
  'settings.referral.desc': 'リンクをシェア。友達がチャージすると、お互い 150 エネルギーが無料に。',
  'settings.referral.yourCode': 'あなたの招待コード',
  'settings.referral.copyCode': '招待コードをコピー',
  'settings.referral.tapToCopy': 'タップでコピー',
  'settings.referral.codeCopied': 'コピーしました',
  'settings.referral.shareLink': 'リンクをシェア',
  'settings.referral.invited_one': '{{count}} 人招待済み',
  'settings.referral.invited_other': '{{count}} 人招待済み',
  'settings.referral.toppedUp_one': '{{count}} 人がチャージ',
  'settings.referral.toppedUp_other': '{{count}} 人がチャージ',
  'settings.referral.pendingHint': '相手の初回チャージ待ち — リマインドしよう！',
  'settings.referral.shareText': '生活の写真から単語を学ぼう。チャージで二人とも 150 エネルギー — Piccard を一緒に：',
  'settings.referral.rewardBanner': '友達がチャージしました — 残高に 150 エネルギーを追加しました。',
  'settings.referral.rewardDismiss': '了解',
  'settings.referral.haveCode': '招待コードありますか？',
  'settings.referral.codePlaceholder': 'コードを入力',
  'settings.referral.codeApply': '適用',
  'settings.referral.codeApplying': '適用中…',
  'settings.referral.codeApplied': 'コードを適用しました — あなたがチャージすると、あなたと招待者がそれぞれ 150 エネルギーを獲得します。',
  'settings.referral.codeAlready': 'このアカウントには既に招待が適用されています。',
  'settings.referral.codeInvalid': 'コードが無効です。',
  'settings.referral.codeSelf': 'それはあなた自身のコードです。',

  // Payment (shared)
  'payment.checkoutFailed': 'チェックアウトを開始できませんでした。もう一度お試しください。',
  'payment.checkoutLoading': 'チェックアウトを開いています…',
  'payment.checkoutSuccess': 'チャージ完了 — ありがとうございます！',
  'payment.checkoutCancelled': 'チェックアウトがキャンセルされました。',

  // Hamburger menu
  'menu.notSignedIn': '未ログイン',
  'menu.signOut': 'ログアウト',
  'menu.languageLearner': '言語学習者',

  // Onboarding
  'onboarding.iSpeak': '私が話すのは…',
  'onboarding.imLearning': '学びたいのは…',
  'onboarding.startLearning': '学習を始める',
  'onboarding.changeAnytime': 'いつでも変更できます。',
  'onboarding.back': '← 戻る',
  'onboarding.learningContext.label': '特定の目標はありますか？',
  'onboarding.learningContext.placeholder': '例：GRE、HSK、ビジネス英語…（任意）',

  // Auth
  'auth.signInPrompt': 'ログインして単語をクラウドに保存しましょう',
  'auth.continueWithGoogle': 'Googleでログイン',
  'auth.continueWithKakao': 'Kakaoで続ける',
  'auth.signingIn': 'ログイン中...',
  'auth.signingYouIn': 'ログインしています...',
  'auth.signInFailed': 'ログインに失敗しました',
  'auth.signInError': '認証中にエラーが発生しました。',
  'auth.tryAgain': '再試行',
  'auth.loading': '読み込み中...',

  // Error boundary
  'error.title': 'エラーが発生しました',
  'error.description': '予期しないエラーが発生しました。',
  'error.tryAgain': '再試行',
  'error.report': '報告',

  // Offline
  'offline.title': 'オフラインです',
  'offline.description': '一部の機能が制限される場合があります。接続を確認してください。',
  'offline.notification': 'オフライン通知',
  'offline.retryConnection': '再接続',

  // PWA install
  'pwa.installPrompt': 'Piccardをインストールしてオフラインで使う',
  'pwa.install': 'インストール',
  'pwa.dismiss': '閉じる',
  'pwa.installAppPrompt': 'アプリのインストール案内',
  'pwa.installApp': 'アプリをインストール',

  // Card stack
  'cardStack.cardGenerated': '1枚のカードを生成しました',
  'cardStack.cardGenerated_other': '{{count}}枚のカードを生成しました',
  'cardStack.counter': '{{current}} / {{total}}枚',
  'cardStack.done': '完了',
  'cardStack.reviewNow': '今すぐ復習',
  'cardStack.generateMore': '続けて生成',
  'cardStack.allReviewed': 'すべてのカードを確認しました',
  'cardStack.cardsSaved': '{{count}}枚のカードを保存しました',
  'cardStack.previousCard': '前のカード',
  'cardStack.nextCard': '次のカード',
  'cardStack.goToCard': 'カード{{n}}に移動',

  // Preview card
  'previewCard.generatedCard': '生成されたカード',
  'previewCard.translation': '翻訳',
  'previewCard.definition': '定義',
  'previewCard.example': '例文',
  'previewCard.searchImagesFor': '{{word}}の画像を検索',

  // Rating buttons
  'rating.again': 'もう一度',
  'rating.hard': '難しい',
  'rating.good': '普通',
  'rating.easy': '簡単',
  'rating.master': '習得',
  'rating.rateAs': '{{label}}と評価',
  'rating.markMastered': '習得済みにする',
  'review.stuckHint': "このカードは{{count}}回抜けました — あなたのせいではありません、定着しないカードもあります。下から外すか、そのまま続けて。",

  // Study card
  'studyCard.studyCardFor': '{{word}}の学習カード',
  'studyCard.playUsPronunciation': '米語の発音を再生',
  'studyCard.playUkPronunciation': '英語の発音を再生',
  'studyCard.searchImagesFor': '{{word}}の画像を検索',

  // Pronunciation button + badge
  'pronunciation.play': '{{accent}}の発音を再生',

  // Search bar
  'search.clearSearch': '検索をクリア',

  // Tag cloud
  'tagCloud.yourTopics': 'あなたのトピック',
  'tagCloud.showMore': '残り{{count}}件の{{label}}を表示',

  // Queue item
  'queueItem.remove': '{{word}}を削除',

  // Error card
  'errorCard.defaultRetry': '再試行',

  // Empty state
  'emptyState.noCards': 'まだカードがありません',
  'emptyState.noCardsHint': '最初のフラッシュカードを作成して始めましょう',
  'emptyState.createCard': 'カードを作成',
  'emptyState.noMastered': 'まだ習得した単語がありません。',
  'emptyState.noMasteredHint': 'カードを習得済みにするとここに表示されます。',
  'emptyState.allMastered': 'すべてのカードを習得しました！',
  'emptyState.greatJob': 'お疲れさまでした！',

  // Progress bar
  'progressBar.cardsLearned': '学習したカード',

  // AI image regeneration (shared RegenerateImageButton)
  'common.aiImage': 'AI画像',
  'common.aiImagePremium': 'Premium',
  'common.aiImageAria': '{{word}}のAI画像を生成',
  'common.generating': '生成中…',
  'common.imageFailed': '失敗 · エネルギー未消費',
  'common.lowEnergy': 'エネルギー不足',
  'common.regenerateCard': '再生成',
  'common.regenerateCardAria': '{{word}} を完全に再生成',

  // Image preview / lightbox
  'imagePreview.enlarge': '画像を拡大',
  'imagePreview.close': '閉じる',

  // Document import view (PDF/TXT → candidate vocab)
  'importView.title': 'ドキュメントを取り込む',
  'importView.subtitle': 'PDFやテキストを単語カードにします。',
  'importView.chooseFile': 'PDFまたはテキストを選択',
  'importView.pasteLabel': 'またはテキストを貼り付け',
  'importView.pastePlaceholder': '記事・メモ・任意のテキストを貼り付け…',
  'importView.findVocab': '語彙を探す',
  'importView.proposing': '語彙を探しています…',
  'importView.proposingWait': '単語を選び、意味を書いています — 長いテキストは10〜20秒です。',
  'importView.phaseReading': 'テキストを読んでいます…',
  'importView.foundSoFar': '{{n}}個見つかりました · まだ探しています…',
  'importView.cancel': 'キャンセル',
  'importView.partialBanner': '{{n}}個見つかりましたが、分析が途中で止まりました。',
  'importView.retryRest': '残りを探す',
  'importView.parsing': 'ドキュメントを読み込んでいます…',
  'importView.candidates': '{{count}}件の候補',
  'importView.keepN': '{{count}}件を残す · {{energy}}エネルギー',
  'importView.generate': '{{count}}枚のカードを作成',
  'importView.selectAll': 'すべて選択',
  'importView.clearAll': 'すべて解除',
  'importView.priorityHigh': '重要度 高',
  'importView.highCount': '重要 {{high}} / 全 {{total}}',
  'mediaView.selectRecommended': 'おすすめを選択',
  'importView.success': '{{count}}枚のカードを追加しました',
  'importView.pairMismatch': 'カードは {{pair}} として保存されます — 現在の設定は {{current}} です。復習前に設定で切り替えてください。',
  'importView.savedAs': '{{pair}} として保存しました',
  'importView.reviewInPair': '{{pair}} に切り替えて復習',
  'importView.reviewNow': '今すぐ復習',
  'importView.errorTooLarge': 'ドキュメントが大きすぎます(最大約80万文字)。',
  'importView.errorScanned': 'テキストを選択できません — スキャンPDFの可能性があります。',
  'importView.errorRead': 'ファイルを読み込めませんでした。',
  'importView.errorPropose': '語彙を抽出できませんでした。もう一度お試しください。',
  'importView.errorRateLimited': '短時間にリクエストが集中しています。1分ほど待ってから、もう一度お試しください。',
  'importView.errorLowEnergy': 'エネルギーが足りません。',
  'importView.empty': '語彙が見つかりませんでした。別のドキュメントをお試しください。',

  // Quick save view (extension lookup → one-step card)
  'quickSave.title': 'Piccard に保存',
  'quickSave.subtitle': 'ワンタップでカードができ、すぐ復習できます。',
  'quickSave.generate': 'カードを生成',
  'quickSave.generateCost': 'カードを生成 · {{energy}} エネルギー',
  'quickSave.generating': 'カードを作成中…',
  'quickSave.slowWait': 'カードの作成には通常数秒かかります — 少々お待ちください。',
  'quickSave.pairSourceExtension': 'この動画から',
  'quickSave.pairSourceSettings': 'アプリの設定',
  'quickSave.pairSourceBrowser': 'ブラウザの言語',
  'quickSave.fromYoutube': 'この動画から',
  'quickSave.fromNetflix': 'この作品から',
  'quickSave.pairLabel': 'カードの言語',
  'quickSave.energyHint': '生成に {{energy}} エネルギー · 残高 {{balance}}',
  'quickSave.errorBalance': 'エネルギーが足りず、カードを生成できません。',
  'quickSave.errorNetwork': 'カードを生成できませんでした。もう一度お試しください。',
  'quickSave.topUp': 'チャージ',
  'card.fromSource': 'ドキュメントから',
  'card.grammar': '文法',
  'card.prosody': 'アクセントとリズム',
  'card.fromClip': 'クリップ',
  'card.fromYoutube': 'YouTube',
  'card.openInNetflix': 'Netflixで開く',
  'card.fromNetflix': 'Netflix',
  'card.fromPdf': 'PDF',
  'card.fromPhoto': 'あなたの写真',
  'card.lookedUp': '調べた単語',
  'card.expand': '展開',
  'card.collapse': '折りたたむ',

  'mediaView.title': '動画をカードにする',
  'mediaView.subtitle': '英語の音声・動画を。文字起こしして、あなたが選びます。',
  'mediaView.chooseFile': 'ファイルをドロップまたはタップ',
  'mediaView.formats': 'mp4 · mov · webm · mp3…',
  'mediaView.cap': '最大90分・最大100MB',
  'mediaView.guideExtension.body': '拡張機能をインストール済み?YouTube/Netflix の動画ページで字幕の単語を選び、Piccard ボタンをタップするとカードを保存できます。下から自分の動画/音声ファイルを取り込むこともできます →',
  'mediaView.guideExtension.dismiss': '閉じる',
  'mediaView.uploading': 'アップロード中…',
  'mediaView.transcribe': '文字起こし',
  'mediaView.transcribing': '文字起こし中…',
  'mediaView.transcribeHint': '短い動画なら数秒で終わります。',
  'mediaView.changeFile': 'ファイルを変更',
  'mediaView.costN': '{{energy}} エネルギー',
  'mediaView.phrases': '{{count}} フレーズ',
  'mediaView.make': '{{count}}枚のカードを作成',
  'mediaView.uncertain': 'このフレーズを確認',
  'mediaView.preview': 'このフレーズを再生',
  'mediaView.success': '{{count}}枚のカードが復習待ちです',
  'mediaView.errorUpload': 'アップロード失敗。もう一度お試しください。',
  'mediaView.errorTooLarge': '100MB超過です。短くしてください。',
  'mediaView.errorSilent': '音声会話が検出されません。無音動画の可能性があります — セリフのある動画を選んでください。',
  'mediaView.errorFormat': '未対応の形式です。mp4・mov・webmまたは音声ファイルを使用してください。',
  'mediaView.errorTranscribe': '文字起こしサービスが混雑中。再試行してください（課金なし）。',
  'mediaView.tooLongDuration': '{{n}} 分を超えています — クリップを短く切ってから再度追加してください。',
  'mediaView.errorContent': 'このファイルに英語の音声は検出されませんでした。',
  'mediaView.errLanguageMismatch': 'この音声は{{lang}}ではないようです。{{lang}}の素材を選ぶか、先に学習言語を切り替えてください。',
  'mediaView.errBadFormat': 'このファイルの実際の形式では文字起こしできません（.avi/.mkv を .mp4 に改名したものなど）。mp4・mov・webm または一般的な音声形式へ変換してください。',
  'mediaView.errNoSpeech': 'このファイルから音声が検出されませんでした。はっきり話のあるクリップを選んでください。',
  'mediaView.errDecode': 'このファイルの音声を処理できませんでした。標準的な mp4・mov・webm または音声ファイルをお試しください。',
  'mediaView.fromFile': '{{name}} から',
  'mediaView.errorLowEnergy': 'エネルギー不足です。',
  'mediaView.errorConfirm': 'これらのフレーズからカードを作成できませんでした。もう一度お試しください。',
  'mediaView.empty': 'この動画にフレーズが見つかりませんでした。',
  'mediaView.costEstimate': '約{{cost}}エネルギー · 約{{min}}分',
  'mediaView.feeApplied': '（{{n}}エネルギーの検出手数料が適用されました）',
  'settings.section.energy': 'エネルギー',
  'settings.section.learning': '学習',
  'redeem.title': 'コードを引き換え',
  'redeem.desc': 'コードを入力してエネルギーを受け取ります。',
  'redeem.placeholder': 'コードを入力',
  'redeem.apply': '引き換え',
  'redeem.applying': '…',
  'redeem.success': '引き換え完了！+{{cents}} エネルギー',
  'redeem.already': 'このコードはすでに引き換え済みです。',
  'redeem.invalid': '無効または期限切れのコード',
  'redeem.error': 'エラーが発生しました。もう一度お試しください。',
  'redeem.balance': '{{balance}} エネルギー利用可能',

  // Landing page (v11 — extension-first entry, closed loop. Copy frozen in
  // docs/plans/landing-v11.md; locale from ?lang / ?ref hint / navigator.languages)
  'landing.hero.title': 'YouTubeで\n英単語を覚える',
  'landing.hero.subtitle':
    '見ている英語動画に、英語と日本語の二か国語字幕を同時表示。気になった一文をタップして、ワンクリックでカードを作ります — 意味・例文・発音つき。カードは忘れる直前に、また戻ってきます。',
  'landing.hero.cta': '無料で始める',
  'landing.hero.ctaNote': '無料です。カード登録も不要です。',
  'landing.hero.ctaExtension': 'Chromeに追加',
  'landing.hero.videoCaption': '二か国語字幕パネルから Piccard へ — 一文から複数の候補カードが生まれます。',
  'landing.how.title': 'YouTube の動画から単語カードへ',
  'landing.how.subtitle': '見たものが、そのまま復習になる。ループは自然と閉じます。',
  'landing.how.step1Title': '二か国語字幕で見る',
  'landing.how.step1Desc': 'Chrome 拡張機能が、見ている動画に日本語字幕を重ねます — 一文ごとに、秒単位で同期。',
  'landing.how.step2Title': '一文をタップして、カードを残す',
  'landing.how.step2Desc':
    'タップひとつでその一文が Piccard へ。ワンクリックでカードが出来上がります — 意味・例文・発音つき。残す価値のあるものを残して、いらないものは捨てるだけ。',
  'landing.how.step3Title': '復習は自動で戻ってくる',
  'landing.how.step3Desc':
    'FSRS の間隔反復が、すべてのカードが忘れる直前に戻るようスケジュールします — 各カードは、生まれた瞬間の YouTube シーンをそのまま再生できます。',
  'landing.how.otherTitle': 'ほかの作り方',
  'landing.how.other3': 'ウェブ上の単語をダブルクリック — オフラインの定義が表示され、もう1クリックで Piccard がカードを作ります。',
  'landing.how.ownLink': '単語帳を持っているなら、そのまま →',

  // landing-v12 P1-2: persona-2 section (OwnMaterial.tsx) — bring your own list
  'landing.bring.title': '持っている単語帳を、そのまま',
  'landing.bring.subtitle': '動画は入り口の一つにすぎません。本当に必要な単語の多くは、もう手元にあります — 教科書の一章、試験の単語帳、講義の録音。貼り付けるかアップロードすれば、Piccardがカードを提案し、残す価値のあるものだけ手元に残ります。',
  'landing.bring.pasteTitle': 'テキストを貼り付け',
  'landing.bring.pasteDesc': '教科書のページ、記事、もう手元にある単語帳。貼り付けると提案カードが返ってきます — 全選択も、絞って残すのも自由です。一度の確定で最大20枚。',
  'landing.bring.pdfTitle': 'PDFをドロップ',
  'landing.bring.pdfDesc': '講義資料、試験の単語リスト、リーディング課題 — PDFも同じ提案フローを通ります。カードが並ぶので選び、一度の確定で終わります。',
  'landing.bring.fileTitle': '音声・動画をアップロード',
  'landing.bring.fileDesc': '英語の講義やポッドキャストの録音(最大90分)は文字起こしされ、各フレーズに「残す価値」スコア0–100(学習目標を反映)が付き、残すものはチェック済みで届きます。アップロードできるのは学習中の言語の音声です(英語学習なら英語の講義)。',
  'landing.bring.cta': 'アプリを開く',
  'landing.bring.ctaNote': '無料で開始。クレジットカードは不要です。',
  'landing.pricing.title': '使った分だけ支払う',
  'landing.pricing.subtitle': '無料エネルギーで開始。チャージはいつでも — 有効期限はありません。',
  'landing.pricing.starter': 'スターター',
  'landing.pricing.starterPrice': '$0',
  'landing.pricing.starterToBegin': 'から始める',
  'landing.pricing.starterGrant': '登録で150エネルギー無料',
  'landing.pricing.starterSwitch': '言語はいつでも切り替え可能',
  'landing.pricing.starterSrs': '間隔反復学習を完全サポート',
  'landing.pricing.starterDevices': 'どのデバイスでも動作',
  'landing.pricing.starterSync': 'クラウド同期込み',
  'landing.pricing.starterCta': '始める',
  'landing.pricing.topup': 'チャージパック',
  'landing.pricing.topupRate': '1エネルギー ≈ テキストカード1枚',
  'landing.pricing.starterAiImage': 'テキストカードは含まれ、AI画像カードは有料機能です',
  'landing.pricing.topupCards': '$5でカード500枚',
  'landing.blog.backHome': '← ホームへ',
    'landing.welcome.openApp': 'Piccard を開く',
  'landing.faq.heading': 'よくある質問',
  'landing.faq.q1': 'Piccardは本当に無料ですか?',
  'landing.faq.a1': 'はい!新しいアカウントには150の無料エネルギーが付与され、動画数本・PDF数部、およそ150枚のカード分です。もっと欲しいときだけ、エネルギーパック($5/$10/$20)でチャージしてください。エネルギーは無期限です。',
  'landing.faq.q2': 'Language ReactorやAnkiと何が違いますか?',
  'landing.faq.a2': 'どちらも良いツールですが、その間には隙間があります。Language Reactor は字幕を表示しますが、単語を残すには Anki へエクスポートしてインポートし直す必要があり、Anki 自体も本格的な設定が要ります — カードは全部自分で作るしかありません。Piccard はその隙間を埋めます。字幕の一文をタップすれば、意味・例文・発音つきのカードが既にできあがっています。残す価値のあるものを残して、あとは捨てる。復習のスケジュールは、Anki も採用する新しい FSRS-6 が組んでくれます。長めの動画を取り込むと、フレーズごとに学ぶ価値スコア(0–100)とホバーで見られる一行理由が付き、学習ゴールも反映されるので、どの単語に時間をかけるべきか迷わずに済みます。設定も、エクスポート/インポートの橋渡しも不要です。',
  'landing.faq.q3': 'YouTubeが重くなったり字幕が壊れたりしませんか?',
  'landing.faq.a3': 'いいえ。拡張機能は軽量です — 動画の上に独自の字幕パネルを重ねて表示するだけで、YouTube自体を編集することはありません。要らなくなれば、ワンクリックで全部取り除けます。アカウントなしでも動作します。',
  'landing.faq.q5': '間隔反復とは何ですか?',
  'landing.faq.a5': '復習のスケジュールを組むアルゴリズムです — 記憶が新しいうちは早い間隔で、長期記憶に定着するにつれて間隔が広がっていきます。Piccard は Anki の背後にある科学の最新世代、FSRS-6 を採用。カードはあなたが見て読んだものから生まれます。',
  'landing.faq.q7': 'どの言語に対応していますか?',
  'landing.faq.a7': '한국어 · 繁體中文 · 日本語を最優先 — Piccardは英語を学ぶ韓国語・繁体字中国語・日本語話者のために作られています。スペイン語・フランス語・ドイツ語も利用可能で、いつでも切り替えられます。',

  'landing.faq.q8': 'すでに単語リストがあります。カードにできますか?',
  'landing.faq.a8': 'はい — 一番速い入り方です。テキストを貼り付けたりPDFをドロップしたりすると、カードが提案されます(一度に最大20枚)。意味・例文・発音入り。講義の録音もOK — 音声をアップロードすると文字起こしされ、各フレーズに残す価値スコア(0–100)が付きます。',
  'landing.faq.q9': 'Netflixでも使えますか？',
  'landing.faq.a9': 'はい、テキスト字幕の作品なら対応します。作品が両方の言語の字幕を提供していれば、動画上に二言語字幕（英語＋自分の言語）も表示されます。パネルを開いたまま観て、気になるフレーズをタップすればカードができ、カードからそのシーンの秒数でNetflixを再び開けます。一部の作品は画像ベース字幕のため読み取れません。またDRMの制約でスクリーンショットや音声の保存はできません — 残るのは単語とその瞬間です。',
  'landing.faq.still': 'まだ質問がありますか?メール:',
  'landing.footer.tagline': '見たものから、単語カードへ',
  'landing.footer.blog': 'ブログ',
  'landing.footer.privacy': 'プライバシー',
  'landing.footer.terms': '利用規約',
  'landing.footer.contact': 'お問い合わせ',
  'landing.footer.rights': 'All rights reserved.',
  'landing.finalCta.title': '最初のフラッシュカードは、YouTube動画ひとつで作れます',
  'landing.finalCta.subtitle': '何かを見る。一文をタップする。カードができる — 忘れる前に、また戻ってきます。',
  'landing.finalCta.cta': '無料で始める',
  'landing.finalCta.ctaExtension': 'Chromeに追加',
  'landing.finalCta.note': 'カード登録不要。150エネルギー込み。',

  // SEO — prerendered HTML shells (docs/plans/multilingual-seo.md M1)
  'seo.title': 'YouTube 英語学習 — 二か国語字幕で英単語カードを作る拡張機能 | Piccard',
  'seo.description':
    'YouTube に英語と日本語の二か国語字幕を同時表示。気になった一文をタップすると完成した単語カードが返ってきて、FSRS 間隔反復で忘れる直前にまた戻ってきます。無料で開始。',
}
